<template>
  <v-card class="elevation-0 pa-2 mb-1" style="border: none!important;">

    <v-layout>

      <img class="c-align-self-start" src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="56px">

      <div class="ml-1">

        <div>
          Inv id: {{ item.id }}
        </div>

        <v-layout align-center class="caption text--text text--darken-1">
          <v-icon color="grey">mdi-qrcode-scan</v-icon>
          <span class="ml-1">{{ archiveItem.id }}</span>
        </v-layout>

        <v-layout>

          <v-layout align-center class="caption text--text text--darken-1">
            <v-icon color="grey">mdi-barcode</v-icon>
            <span class="ml-1">{{ archiveItem.batch_number || 'batch number not set'}}</span>
          </v-layout>

          <v-spacer></v-spacer>

          <v-layout align-end justify-end class="caption text-xs-right">
            <div>
              <div v-if="expiryDateHuman">
                {{ expiryDateHuman }}
              </div>
              <div class="ml-1">
                {{ expiryDate || 'expiry not set'}}
              </div>
            </div>
            <v-icon small color="grey">mdi-calendar-range</v-icon>
          </v-layout>

        </v-layout>

        <div class="text-xs-right">
          <c-metric-selector
          :inventoryItemID="item.inventory_item_id" 
          :realValue="inputs[item.id]"
          :key="item.id + 'a'"
          labelMode
          alwaysScale
          class="text-sans"
          >
          </c-metric-selector>
          /
          <c-metric-selector
          :inventoryItemID="item.inventory_item_id" 
          :realValue="item.quantity"
          :key="item.id + 'b'"
          labelMode
          alwaysScale
          class="text-sans"
          >
          </c-metric-selector>
        </div>

        <v-card style="border-radius: 40px; padding: 10px 20px;">
          <v-layout align-center>
            <c-metric-selector
            :inventoryItemID="item.inventory_item_id" 
            :realValue.sync="inputs[item.id]"
            :key="item.id + 'b'"
            class="text-sans mt-1 font-weight-medium subheading"
            >
              <v-progress-linear
              class="ma-0"
              v-model="percent"
              slot="progress"
              color="color1"
              height="3"
              ></v-progress-linear>
            </c-metric-selector>

            <v-btn icon flat small class="ma-0"
            @click="clearQuantity">
              <v-icon small color="color1">mdi-close</v-icon>
            </v-btn>

            <v-btn icon flat small class="ma-0"
            @click="useFullQuantity">
              <v-icon small color="color1">mdi-arrow-down</v-icon>
            </v-btn>
          </v-layout>
        </v-card>

        <div v-if="inputs[item.id] > item.quantity"
        class="red--text caption">
          * Insufficient stock,
          short 
          <c-metric-selector
          :inventoryItemID="item.inventory_item_id" 
          :realValue="inputs[item.id] - item.quantity"
          :key="item.id"
          alwaysScale
          labelMode
          class="text-sans"
          ></c-metric-selector>
        </div>
        <div v-else
        class="text-xs-center caption">
          {{ percent.toFixed(2) }}%
        </div>

      </div>
    </v-layout>
  </v-card>
</template>

<script>
import Vue from 'vue'

export default {
  props: ['item', 'inputs'],
  computed: {
    archiveItem () {
      return this.$store.state.db.inventoryArchive.archive[this.item.archive_id]
    },
    percent () {
      var percent = 100 - (((this.item.quantity - this.inputs[this.item.id]) / this.item.quantity) * 100)
      return isNaN(percent) ? 0 : percent
    },
    expiryDateIsValid () {
      return this.$moment.utc(this.archiveItem.expiry_date).isValid()
    },
    expiryDate () {
      if (this.$moment.utc(this.archiveItem.expiry_date).isValid()) {
        return this.$moment(this.archiveItem.expiry_date).format('DD/MM/YYYY')
      }
      return ''
    },
    expiryDateHuman () {
      if (this.$moment.utc(this.archiveItem.expiry_date).isValid()) {
        return this.$moment.utc(this.archiveItem.expiry_date).fromNow()
      }
      return ''
    }
  },
  methods: {
    useFullQuantity () {
      Vue.set(this.inputs, this.item.id, this.item.quantity)
    },
    clearQuantity () {
      Vue.set(this.inputs, this.item.id, 0)
    }
  }
}
</script>
